import { useI18n } from 'vue-i18n'

export type TranslationInput =
	| string
	| { key: string; params: {} }
	| { key: string; params: { count?: number; rest?: string } }
	| { key: string; count: number }
	| number
	| undefined
	| null

export function useTranslate() {
	const { t, te } = useI18n()

	function translate(input: TranslationInput): string | undefined {
		if (!input) return ''

		if (typeof input === 'string') {
			return t(input)
		}

		if (typeof input === 'number') {
			return String(input)
		}

		if ('key' in input) {
			const key = input.key
			let count =
				'count' in input && typeof input.count === 'number' ? input.count : 1
			let rest = ''
			if ('params' in input && input.params) {
				const params = input.params ? { ...input.params } : {}

				if (params?.rest) {
					rest = params.rest
					delete params.rest
				}

				return t(key, { count, ...params }) + rest
			}
			return t(key, { count }) + rest
		}
		return t(input)
	}
	return { translate, te }
}
